import Parser from 'html-react-parser';
import l from '../../../../lang';
import { usePaymentIntegration } from '../../../../store/payment-integration';
import { DetailsOpened } from '../../../../store/payment-integration/interfaces';
import { ReactComponent as VirtuemartIcon } from '../../../../assets/icons/integrations/virtuemart.svg';
import IntegrationDetails from '../integration-details';
import { Button } from '../../../common/button';
import { openNewTabAndFocus, getLanguage } from '../../../../utils';
import { Urls } from '../../../../config/urls';

export default () => {
  const { setDetailsOpened } = usePaymentIntegration();

  return (
    <IntegrationDetails icon={<VirtuemartIcon />} color="blue" onClose={() => setDetailsOpened(DetailsOpened.NONE)}>
      <div className="integration_details__title">{l('paymentIntegration.virtuemart.details.headline')}</div>
      <p>
        <span>{Parser(l('paymentIntegration.virtuemart.details.description'))}</span>
      </p>
      <Button
        className="integration_details__button"
        onClick={() => {
          openNewTabAndFocus(Urls.docs.teaserIntegrations[getLanguage()]);
        }}
      >
        {l('paymentIntegration.card.integration.voting.link')}
      </Button>
    </IntegrationDetails>
  );
};
